export default __webpack_public_path__ + "static/carpe-fb3bfbcd1673c2fd18ee97ebb6581976.png";